import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchNudges } from 'src/legacy/redux/actions/chatUsers.jsx';

import NudgesView from './view.jsx';

const mapStateToProps = (state) => {
  return {
    loading: _.get(state.legacyRootReducer, 'chatUser.nudges.loading'),
    nudges: _.get(state.legacyRootReducer, 'chatUser.nudges.items')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNudges: () => {
      return dispatch(fetchNudges());
    }
  }
}

const Nudges = connect(
  mapStateToProps,
  mapDispatchToProps
)(NudgesView)

export default Nudges;